import Image from 'next/image';
import React from 'react';

const ErrorPage = () => {
    return (
        <>
            <section className="hero technology-herosection errorpage-height">
                <div className="container lg:container md:mx-auto top-hero">
                    <div className="text-center lg:w-6/12 mx-auto">
                        <Image
                            src="/img/img-error@2x.webp"
                            alt="error"
                            title="error"
                            height="415"
                            width="460"
                            loading="lazy"
                            data-aos="fade-up"
                            data-aos-duration={1000}
                            data-aos-delay={100}
                            className="mb-5 img-fluid"
                        />
                        <h1 className="fs-xl mb-4 dark:text-textcolor">Oops! Page not found</h1>
                        <p className="fs-md text-black">
                            We’re sorry we have lost our spark or this page does not exist. Try the links below to start your
                            experience again.
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ErrorPage;
